import type { BehindText } from "@hudhud/core";
import { clampMap } from "./interpolate.js";

export const BEHIND_IN = 10;
/** A behind-the-speaker block `frame` frames into its `frames`-long span: its opacity and rise. */
export function behindMotion(item: Pick<BehindText, "animation" | "opacity">, frame: number, frames: number): { opacity: number; ty: number } {
  const enter = item.animation === "none" ? 1 : clampMap(frame, [0, BEHIND_IN], [0, 1]);
  const leave = clampMap(frame, [frames - BEHIND_IN, frames], [1, 0]);
  return { opacity: item.opacity * enter * leave, ty: item.animation === "rise" ? (1 - enter) * 40 : 0 };
}
